/** @license mt-block-editor-block-form-element

Copyright (c) 2020 Six Apart Ltd.

This source code is licensed under the MIT license found in the
LICENSE file in the root directory of this source tree.
*/
import "./i18n";
import Input from "./Block/Input";
import Textarea from "./Block/Textarea";
import Select from "./Block/Select";

window.MTBlockEditor.registerBlockType(Input);
window.MTBlockEditor.registerBlockType(Textarea);
window.MTBlockEditor.registerBlockType(Select);
